import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { Injectable, Injector } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { retry, mergeMap, first, catchError } from "rxjs/operators";
import { EslIdAuthService } from "./ng1/eslid/EslIdAuthService";
declare var Drupal: any;

@Injectable()
export class ESLApiInterceptor implements HttpInterceptor {
    constructor(protected tokenService: EslIdAuthService, protected injector: Injector) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const noAuthUrls = ["/metarank/v1/ranking", "/user/oauth2/access-token"];

        if (noAuthUrls.filter(url => req.url.includes(url)).length > 0) {
            return next.handle(req);
        }

        const token = this.tokenService.getAuthToken(Drupal.settings.user.id);
        req = req.clone({
            headers: req.headers.set("Authorization", `Bearer ${token}`),
        });

        return next.handle(req).pipe(
            catchError(error => {
                if (error.status !== 401) {
                    return throwError(error);
                }

                // Needed to not do a circular dependency
                const http = this.injector.get(HttpClient);

                return http.get("/user/oauth2/access-token", { observe: "response" }).pipe(
                    retry(5),
                    first(),
                    mergeMap(response => {
                        const newToken = response.headers.get("X-Auth-Token");
                        this.tokenService.setAuthToken(Drupal.settings.user.id, newToken);

                        return next.handle(
                            req.clone({
                                headers: req.headers.set("Authorization", `Bearer ${newToken}`),
                            })
                        );
                    }),
                    catchError(x => throwError(error))
                );
            })
        );
    }
}

export const eslAPIInterceptorProviders = {
    provide: HTTP_INTERCEPTORS,
    useClass: ESLApiInterceptor,
    multi: true,
};
